// Setting type name as returned by the API (`setting_types.name` = 'banksettings',
// serialized through ucwords() in SettingTypeData::fromModel()).
export const BANK_SETTING_TYPE = 'Banksettings'
